<script lang="ts">
  import type { CtaPageSectionBlock } from '@storyblok-types';

  import MediaBannerPageSection from './MediaBannerPageSection.svelte';
  import type { WithTrustpilotServiceReview } from '$lib/server/expanders/withTrustpilotReview';

  const { blok }: { blok: WithTrustpilotServiceReview<CtaPageSectionBlock> } = $props();
</script>

<MediaBannerPageSection blok={{ ...blok, component: 'mediaBannerPageSection' }} />
